import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

function createSwiperCarousel() {
    const swipers = document.querySelectorAll('.swiper-carousel');

    if(swipers.length == 0) return;

    swipers.forEach((e) => {


        const slidesPerColumn = e.getAttribute('data-slides-per-column') ?? 1;
        const slidesPerView = e.getAttribute('data-slides-per-view') ?? 1;
        const spaceBetween = e.getAttribute('data-space-between') ?? 24;
       
        const slidesPerColumnMd = e.getAttribute('data-slides-per-column-md') ?? slidesPerColumn;
        const slidesPerViewMd = e.getAttribute('data-slides-per-view-md') ?? slidesPerColumn;
        const spaceBetweenMd = e.getAttribute('data-space-between-md') ?? slidesPerColumn;
       
        const slidesPerColumnLg = e.getAttribute('data-slides-per-column-lg') ?? slidesPerColumnMd;
        const slidesPerViewLg = e.getAttribute('data-slides-per-view-lg') ?? slidesPerViewMd;
        const spaceBetweenLg = e.getAttribute('data-space-between-lg') ?? spaceBetweenMd;
       
        const slidesPerColumnXl = e.getAttribute('data-slides-per-column-xl') ?? slidesPerColumnLg;
        const slidesPerViewXl = e.getAttribute('data-slides-per-view-xl') ?? slidesPerViewLg;
        const spaceBetweenLXl = e.getAttribute('data-space-between-xl') ?? spaceBetweenLg;
        
        const fade = e.getAttribute('data-fade') ?? false;

        console.log(fade);

        const swiperOptions = {
            modules: [Navigation, Pagination, Autoplay, EffectFade],
            slidesPerView: slidesPerView,
            slidesPerColumn: slidesPerColumn,
            centeredSlides: true,
            effect: fade,
            spaceBetween: spaceBetween,
            crossFade: true,
            speed: 1000,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-carousel-button-next",
                prevEl: ".swiper-carousel-button-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: slidesPerViewMd,
                    slidesPerColumn: slidesPerColumnMd,
                    spaceBetween: spaceBetweenMd,
                },
                992: {
                    slidesPerView: slidesPerViewLg,
                    slidesPerColumn: slidesPerColumnLg,
                    spaceBetween: spaceBetweenLg,
                },
                1200: {
                    slidesPerView: slidesPerViewXl,
                    slidesPerColumn: slidesPerColumnXl,
                    spaceBetween: spaceBetweenLXl,
                }
            }
        };


        const swiperInstance = new Swiper(e, swiperOptions);


    });

}

document.addEventListener('DOMContentLoaded', () => {

    createSwiperCarousel();

}); 
